import React from "react";
import "../../Create_Assessment_PreRead/HomeworkPreRead/AddPreRead.css";
import { Link } from "react-router-dom";

function AddPreRead() {
  return (
    <div className="addHW_container_preRead">
      <div>
        <h3 className="m-0">Add Pre-read</h3>
        <div className="pre-read-text_add">
          No content here yet, click below button to add pre-read materials.
        </div>
        <div>
          <Link to="/createPreRead">
          <button id="addPreReadBtn"><img src="/ContentM_images/addButton.svg"/> Add </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AddPreRead;
